import { Link } from "react-router";

export function AdverseMediaSettingsHint({
  configured,
  className = "",
}: {
  configured: boolean;
  className?: string;
}) {
  return (
    <p className={`text-small text-grey-900 ${className}`}>
      {configured
        ? "Adverse Media settings are already configured for your company."
        : "Adverse Media settings are not configured for your company."}{" "}
      <Link to="/company-settings?tab=adv-media-settings" className="text-blue-600 underline">
        Check Settings
      </Link>
    </p>
  );
}

export function AdverseMediaEntityTypeHint({ className = "" }: { className?: string }) {
  return (
    <p role="alert" className={`text-small font-medium text-red-600 ${className}`}>
      Adverse Media only supports the Individual and Organization entity types — search by one, the
      other, or both.
    </p>
  );
}

export function AdverseMediaNameRequiredHint({ className = "" }: { className?: string }) {
  return (
    <p role="alert" className={`px-1 text-tiny font-medium text-red-600 ${className}`}>
      Adverse Media requires a name to search.
    </p>
  );
}
